import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCurrencyDollar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 4.8C9.01738 4.8 6.59998 6.411 6.59998 8.4C6.59998 10.389 9.01738 12 12 12C14.9826 12 17.4 13.611 17.4 15.6C17.4 17.589 14.9826 19.2 12 19.2M12 4.8V19.2M12 4.8C13.998 4.8 15.744 5.5236 16.6782 6.6M12 4.8V3M12 19.2V21M12 19.2C10.002 19.2 8.25598 18.4764 7.32178 17.4",
		stroke: "currentColor",
		strokeWidth: 1.875,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCurrencyDollar;
